import React from 'react';
import {MenuItem, Stack, TextField, Typography} from '@mui/material';

interface OperatorSelectorProps {
  groupId: string;
  operator: 'all' | 'any';
  accessibleLabel: string;
  onChange: (groupId: string, operator: 'all' | 'any') => void;
}

export const OperatorSelector: React.FC<OperatorSelectorProps> = ({
  groupId, operator, accessibleLabel, onChange,
}) => (
  <Stack direction="row" alignItems="center" spacing={1} mb={1.5}>
    <TextField
      select
      size="small"
      value={operator}
      onChange={event => onChange(groupId, event.target.value as 'all' | 'any')}
      inputProps={{'aria-label': accessibleLabel}}
      sx={{
        width: 58,
        '& .MuiSelect-select': {
          py: 0,
          pl: 1,
          pr: '20px !important',
          fontSize: '11px !important',
          fontWeight: 700,
          lineHeight: '22px',
          color: '#fff !important',
          overflow: 'visible',
          textOverflow: 'clip',
        },
        '& .MuiOutlinedInput-root': {
          bgcolor: operator === 'any' ? '#ff8d35' : '#3a618e',
          color: '#fff',
          borderRadius: 1,
          height: 22,
        },
        '& .MuiSvgIcon-root': {color: '#fff !important', fontSize: 16, right: 3},
        '& fieldset': {border: 0},
      }}
    >
      <MenuItem value="all">ALL</MenuItem>
      <MenuItem value="any">ANY</MenuItem>
    </TextField>
    <Typography>of the following conditions must be met:</Typography>
  </Stack>
);
